"use client"
// NIVEAU MARIAGE : Julia en robe de mariée avec bouquet
export function drawJuliaWeddingLevel(ctx: CanvasRenderingContext2D, x: number, y: number, isRunning: boolean = false, runningTime: number = 0): void {
ctx.save();

// Animation de course - balancement des bras et jambes
const swayOffset = isRunning ? Math.sin(runningTime * 0.3) * 2 : 0;
const armSwayOffset = isRunning ? Math.sin(runningTime * 0.3) * 1.5 : 0;


// Robe de mariée (blanche, ultra bouffante, style "robe princesse")
ctx.fillStyle = '#fff';
ctx.beginPath();
ctx.moveTo(x + 14, y + 18); // haut de la robe
ctx.bezierCurveTo(x - 40, y + 60, x + 68, y + 60, x + 14, y + 40); // jupe très large et arrondie
ctx.bezierCurveTo(x - 10, y + 60, x + 38, y + 60, x + 14, y + 18); // effet "double jupe"
ctx.closePath();
ctx.fill();
// Motifs de dentelle
// ctx.strokeStyle = '#f3e6fa';
// ctx.lineWidth = 2;
// ctx.setLineDash([4, 4]);
// ctx.beginPath();
// ctx.moveTo(x + 14, y + 18);
// ctx.bezierCurveTo(x - 40, y + 60, x + 68, y + 60, x + 14, y + 90);
// ctx.stroke();
// ctx.setLineDash([]);
// Buste
ctx.fillStyle = '#fff';
ctx.fillRect(x + 10, y + 18, 8, 18);
ctx.strokeStyle = '#e0e0e0';
ctx.strokeRect(x + 10, y + 18, 8, 18);

// Voile (translucide)
// ctx.globalAlpha = 0.25;
// ctx.fillStyle = '#b3e0ff';
// ctx.beginPath();
// ctx.ellipse(x + 14, y + 10, 13, 12, 0, 0, Math.PI * 2);
// ctx.fill();
// ctx.globalAlpha = 1;

// Corps (peau)
ctx.fillStyle = '#FFDBAC';
ctx.fillRect(x + 11, y + 12, 6, 9);
ctx.fillRect(x + 10, y + 9, 8, 6);

// Tête
ctx.fillStyle = '#FFDBAC';
ctx.fillRect(x + 8, y + 3, 12, 9);

// Cheveux blonds
ctx.fillStyle = '#FFD700';
ctx.fillRect(x + 7 + swayOffset * 0.5, y + 1, 14, 4);
ctx.fillRect(x + 5 + swayOffset, y + 4, 3, 7);
ctx.fillRect(x + 20 + swayOffset, y + 4, 3, 7);

// Yeux
ctx.fillStyle = '#000000';
ctx.fillRect(x + 10, y + 6, 2, 2);
ctx.fillRect(x + 16, y + 6, 2, 2);

// Bouche (souriante)
ctx.fillStyle = '#FF1493';
ctx.fillRect(x + 13, y + 9, 2, 1);

// Bras animés : les DEUX bras tendus vers Ben (à droite), sans bouquet
if (isRunning) {
  const armWave = Math.sin(runningTime * 0.3) * 2;
  // Bras gauche tendu vers Ben (même logique que le droit, mais légèrement plus bas)
  ctx.save();
  ctx.fillStyle = '#FFDBAC';
  // Premier segment horizontal (gauche)
  ctx.fillRect(x + 13, y + 19 + armWave, 8, 3);
  // Extension gauche
  ctx.fillRect(x + 21, y + 20 + armWave, 4, 2);
  // Main gauche
  ctx.fillRect(x + 24, y + 21 + armWave, 3, 3);
  // Effet de mouvement gauche
  ctx.fillStyle = 'rgba(255, 182, 193, 0.5)';
  ctx.fillRect(x + 27, y + 22 + armWave, 2, 1);
  ctx.fillRect(x + 26, y + 24 + armWave, 3, 1);
  ctx.restore();

  // Bras droit très tendu vers Ben (deux segments + extension)
  ctx.save();
  ctx.fillStyle = '#FFDBAC';
  // Premier segment horizontal (droit)
  ctx.fillRect(x + 19, y + 15 - armWave, 6, 3);
  // Extension vers Ben
  ctx.fillRect(x + 25, y + 16 - armWave, 4, 2);
  // Main droite
  ctx.fillRect(x + 28, y + 17 - armWave, 3, 3);
  // Effet de mouvement droit
  ctx.fillStyle = 'rgba(255, 182, 193, 0.7)';
  ctx.fillRect(x + 31, y + 18 - armWave, 2, 1);
  ctx.fillRect(x + 30, y + 20 - armWave, 3, 1);
  ctx.restore();
} else {
  // Bras normaux
  ctx.save();
  ctx.translate(x + 11, y + 18);
  ctx.rotate(-0.05);
  ctx.fillStyle = '#FFDBAC';
  ctx.fillRect(-2, 0, 4, 18);
  ctx.restore();
  ctx.save();
  ctx.translate(x + 17, y + 18);
  ctx.rotate(0.05);
  ctx.fillStyle = '#FFDBAC';
  ctx.fillRect(-2, 0, 4, 18);
  ctx.restore();
}

// Jambes avec animation
// ctx.fillStyle = '#FFDBAC';
// const legSwayOffset = isRunning ? Math.sin(runningTime * 0.3 + Math.PI) * 1 : 0;
// ctx.fillRect(x + 10 + legSwayOffset, y + 39, 3, 6);
// ctx.fillRect(x + 15 - legSwayOffset, y + 39, 3, 6);

// Chaussures blanches
// ctx.fillStyle = '#bbb';
// ctx.fillRect(x + 9 + legSwayOffset, y + 42, 4, 3);
// ctx.fillRect(x + 15 - legSwayOffset, y + 42, 4, 3);


ctx.restore();
}

export interface DrawingContext {
ctx: CanvasRenderingContext2D
cameraX: number
canvasWidth: number
canvasHeight: number
}

export interface Character {
x: number
y: number
isRunning?: boolean
runningTime?: number
jumpHeight?: number
}

// Fonctions de dessin de base pour les personnages
export class CharacterRenderer {

// Dessiner Julia (fille blonde) en pixel art avec animation de course
static drawJulia(ctx: CanvasRenderingContext2D, x: number, y: number, isRunning: boolean = false, runningTime: number = 0): void {
	ctx.save()

	// Animation de course - balancement des bras et jambes
	const swayOffset = isRunning ? Math.sin(runningTime * 0.3) * 2 : 0
	const armSwayOffset = isRunning ? Math.sin(runningTime * 0.3) * 1.5 : 0

	// Robe rose
	ctx.fillStyle = '#FF69B4'
	ctx.fillRect(x + 8, y + 18, 12, 18) // Corps de la robe
	ctx.fillRect(x + 5, y + 30, 18, 9) // Bas de la robe élargi

	// Corps (peau)
	ctx.fillStyle = '#FFDBAC'
	ctx.fillRect(x + 11, y + 12, 6, 9) // Torse
	ctx.fillRect(x + 10, y + 9, 8, 6) // Cou

	// Tête
	ctx.fillStyle = '#FFDBAC'
	ctx.fillRect(x + 8, y + 3, 12, 9) // Visage

	// Cheveux blonds avec mouvement
	ctx.fillStyle = '#FFD700'
	ctx.fillRect(x + 7 + swayOffset * 0.5, y + 1, 14, 4) // Cheveux du haut
	ctx.fillRect(x + 5 + swayOffset, y + 4, 3, 7) // Cheveux côté gauche (longs)
	ctx.fillRect(x + 20 + swayOffset, y + 4, 3, 7) // Cheveux côté droit (longs)

	// Yeux
	ctx.fillStyle = '#000000'
	ctx.fillRect(x + 10, y + 6, 2, 2) // Œil gauche
	ctx.fillRect(x + 16, y + 6, 2, 2) // Œil droit

	// Bouche (sourire)
	ctx.fillStyle = '#FF1493'
	ctx.fillRect(x + 13, y + 9, 2, 1) // Bouche

	// Bras avec animation de course - Julia tend les bras vers Ben
	ctx.fillStyle = '#FFDBAC'
	if (isRunning) {
	// Animation des bras qui tendent vers Ben (à droite)
	const armWave = Math.sin(runningTime * 0.3) * 2 // Mouvement plus subtil

	// Bras gauche - mouvement de balancier
	ctx.fillRect(x + 6 + armWave, y + 15, 3, 6) // Bras gauche normal

	// Bras droit - tendu vers Ben avec extension
	ctx.fillRect(x + 19, y + 15 - armWave, 6, 3) // Bras droit étendu
	ctx.fillRect(x + 25, y + 16 - armWave, 4, 2) // Extension du bras vers Ben
	ctx.fillRect(x + 29, y + 17 - armWave, 3, 2) // Extension encore plus loin

	// Mains expressives
	ctx.fillRect(x + 6 + armWave, y + 21, 3, 3) // Main gauche normale
	ctx.fillRect(x + 31, y + 18 - armWave, 3, 3) // Main droite tendue vers Ben

	// Effet de mouvement - petites lignes vers Ben
	ctx.fillStyle = 'rgba(255, 182, 193, 0.8)'
	ctx.fillRect(x + 34, y + 19 - armWave, 2, 1) // Trait de vitesse
	ctx.fillRect(x + 33, y + 21 - armWave, 3, 1) // Trait de vitesse
	ctx.fillRect(x + 32, y + 23 - armWave, 2, 1) // Trait de vitesse

	ctx.fillStyle = '#FFDBAC' // Restaurer la couleur
	} else {
	// Bras normaux
	ctx.fillRect(x + 6, y + 15, 3, 6) // Bras gauche
	ctx.fillRect(x + 19, y + 15, 3, 6) // Bras droit
	}

	// Jambes avec animation de course
	ctx.fillStyle = '#FFDBAC'
	const legSwayOffset = isRunning ? Math.sin(runningTime * 0.3 + Math.PI) * 1 : 0
	ctx.fillRect(x + 10 + legSwayOffset, y + 39, 3, 6) // Jambe gauche
	ctx.fillRect(x + 15 - legSwayOffset, y + 39, 3, 6) // Jambe droite

	// Chaussures roses avec animation
	ctx.fillStyle = '#FF1493'
	ctx.fillRect(x + 9 + legSwayOffset, y + 42, 4, 3) // Chaussure gauche
	ctx.fillRect(x + 15 - legSwayOffset, y + 42, 4, 3) // Chaussure droite

	ctx.restore()
}

// Dessiner Ben (garçon blond) en pixel art avec animation de course
static drawBen(ctx: CanvasRenderingContext2D, x: number, y: number, isRunning: boolean = false, runningTime: number = 0, reachingOut: boolean = true): void {
	ctx.save()

	// T-shirt bleu
	ctx.fillStyle = '#4169E1'
	ctx.fillRect(x + 8, y + 18, 12, 12) // T-shirt

	// Short vert
	ctx.fillStyle = '#228B22'
	ctx.fillRect(x + 9, y + 30, 10, 9) // Short

	// Corps (peau)
	ctx.fillStyle = '#FFDBAC'
	ctx.fillRect(x + 11, y + 12, 6, 6) // Cou

	// Tête
	ctx.fillStyle = '#FFDBAC'
	ctx.fillRect(x + 8, y + 3, 12, 9) // Visage

	// Cheveux blonds
	ctx.fillStyle = '#FFD700'
	ctx.fillRect(x + 7, y + 1, 14, 4) // Cheveux du haut
	ctx.fillRect(x + 5, y + 4, 3, 4) // Cheveux côté gauche
	ctx.fillRect(x + 20, y + 4, 3, 4) // Cheveux côté droit

	// Yeux (plus expressifs quand il court)
	ctx.fillStyle = '#000000'
	if (isRunning) {
	// Yeux déterminés/concentrés
	ctx.fillRect(x + 10, y + 6, 2, 2) // Œil gauche
	ctx.fillRect(x + 16, y + 6, 2, 2) // Œil droit
	// Petites lignes de concentration
	ctx.fillRect(x + 9, y + 5, 1, 1)
	ctx.fillRect(x + 18, y + 5, 1, 1)
	} else {
	ctx.fillRect(x + 10, y + 6, 2, 2) // Œil gauche
	ctx.fillRect(x + 16, y + 6, 2, 2) // Œil droit
	}

	// Bouche (sourire déterminé quand il court)
	ctx.fillStyle = '#8B4513'
	if (isRunning) {
	ctx.fillRect(x + 12, y + 9, 4, 1) // Sourire déterminé plus large
	} else {
	ctx.fillRect(x + 13, y + 9, 2, 1) // Bouche normale
	}

	// Bras - animation de course
	ctx.fillStyle = '#4169E1'
	if (isRunning) {
	const armWave = Math.sin(runningTime * 0.3) * 2 // Mouvement plus subtil

	if (reachingOut) {
		// Animation des bras qui tendent vers Julia (à droite)
		// Bras gauche - mouvement de balancier
		ctx.fillRect(x + 5, y + 18 + armWave, 3, 9) // Manche gauche

		// Bras droit - tendu vers Julia avec plus d'extension
		ctx.fillRect(x + 20, y + 18 - armWave, 6, 3) // Manche droite étendue
		ctx.fillRect(x + 26, y + 19 - armWave, 4, 2) // Extension du bras vers Julia

		// Mains expressives
		ctx.fillStyle = '#FFDBAC'
		ctx.fillRect(x + 5, y + 27 + armWave, 3, 3) // Main gauche
		ctx.fillRect(x + 29, y + 20 - armWave, 3, 3) // Main droite tendue vers Julia

		// Effet de mouvement - petites lignes
		ctx.fillStyle = 'rgba(255, 255, 255, 0.7)'
		ctx.fillRect(x + 32, y + 21 - armWave, 2, 1) // Trait de vitesse
		ctx.fillRect(x + 31, y + 23 - armWave, 3, 1) // Trait de vitesse
	} else {
		// Ben fuit - bras normaux en mouvement de course
		ctx.fillRect(x + 5, y + 18 + armWave, 3, 9) // Manche gauche
		ctx.fillRect(x + 20, y + 18 - armWave, 3, 9) // Manche droite

		// Mains normales
		ctx.fillStyle = '#FFDBAC'
		ctx.fillRect(x + 5, y + 27 + armWave, 3, 3) // Main gauche
		ctx.fillRect(x + 20, y + 27 - armWave, 3, 3) // Main droite
	}
	} else {
	// Bras normaux
	ctx.fillRect(x + 5, y + 18, 3, 9) // Manche gauche
	ctx.fillRect(x + 20, y + 18, 3, 9) // Manche droite

	ctx.fillStyle = '#FFDBAC'
	ctx.fillRect(x + 5, y + 27, 3, 3) // Main gauche
	ctx.fillRect(x + 20, y + 27, 3, 3) // Main droite
	}

	// Jambes (avec animation de course)
	ctx.fillStyle = '#FFDBAC'
	if (isRunning) {
	const legMovement = Math.sin(runningTime * 0.4) * 1
	ctx.fillRect(x + 10, y + 39 + legMovement, 3, 6) // Jambe gauche
	ctx.fillRect(x + 15, y + 39 - legMovement, 3, 6) // Jambe droite
	} else {
	ctx.fillRect(x + 10, y + 39, 3, 6) // Jambe gauche
	ctx.fillRect(x + 15, y + 39, 3, 6) // Jambe droite
	}

	// Baskets blanches
	ctx.fillStyle = '#FFFFFF'
	if (isRunning) {
	const legMovement = Math.sin(runningTime * 0.4) * 1
	ctx.fillRect(x + 8, y + 42 + legMovement, 5, 3) // Basket gauche
	ctx.fillRect(x + 15, y + 42 - legMovement, 5, 3) // Basket droite

	// Lacets noirs
	ctx.fillStyle = '#000000'
	ctx.fillRect(x + 10, y + 42 + legMovement, 1, 1) // Lacet gauche
	ctx.fillRect(x + 17, y + 42 - legMovement, 1, 1) // Lacet droit

	// Nuage de poussière sous les pieds
	ctx.fillStyle = 'rgba(139, 115, 85, 0.5)'
	ctx.fillRect(x + 6, y + 45, 8, 2)
	ctx.fillRect(x + 13, y + 45, 8, 2)
	} else {
	ctx.fillRect(x + 8, y + 42, 5, 3) // Basket gauche
	ctx.fillRect(x + 15, y + 42, 5, 3) // Basket droite

	// Lacets noirs
	ctx.fillStyle = '#000000'
	ctx.fillRect(x + 10, y + 42, 1, 1) // Lacet gauche
	ctx.fillRect(x + 17, y + 42, 1, 1) // Lacet droit
	}

	ctx.restore()
}

// Dessiner Ben et Julia en train de se faire un câlin
static drawHuggingCouple(ctx: CanvasRenderingContext2D, benX: number, benY: number, juliaX: number, juliaY: number, animationTime: number): void {
	ctx.save()

	// Effet de scintillement doux
	const glowIntensity = 0.5 + 0.3 * Math.sin(animationTime * 0.2)
	ctx.shadowColor = '#FFD700'
	ctx.shadowBlur = 10 * glowIntensity

	// Dessiner Julia (à droite dans le câlin)
	// Robe rose
	ctx.fillStyle = '#FF69B4'
	ctx.fillRect(juliaX + 8, juliaY + 18, 12, 18) // Corps de la robe
	ctx.fillRect(juliaX + 5, juliaY + 30, 18, 9) // Bas de la robe élargi

	// Corps Julia (peau)
	ctx.fillStyle = '#FFDBAC'
	ctx.fillRect(juliaX + 11, juliaY + 12, 6, 9) // Torse
	ctx.fillRect(juliaX + 10, juliaY + 9, 8, 6) // Cou

	// Tête Julia
	ctx.fillStyle = '#FFDBAC'
	ctx.fillRect(juliaX + 8, juliaY + 3, 12, 9) // Visage

	// Cheveux blonds Julia
	ctx.fillStyle = '#FFD700'
	ctx.fillRect(juliaX + 7, juliaY + 1, 14, 4) // Cheveux du haut
	ctx.fillRect(juliaX + 5, juliaY + 4, 3, 7) // Cheveux côté gauche (longs)
	ctx.fillRect(juliaX + 20, juliaY + 4, 3, 7) // Cheveux côté droit (longs)

	// Dessiner Ben (à gauche dans le câlin)
	// T-shirt bleu
	ctx.fillStyle = '#4169E1'
	ctx.fillRect(benX + 8, benY + 18, 12, 12) // T-shirt

	// Short vert
	ctx.fillStyle = '#228B22'
	ctx.fillRect(benX + 9, benY + 30, 10, 9) // Short

	// Corps Ben (peau)
	ctx.fillStyle = '#FFDBAC'
	ctx.fillRect(benX + 11, benY + 12, 6, 6) // Cou

	// Tête Ben
	ctx.fillStyle = '#FFDBAC'
	ctx.fillRect(benX + 8, benY + 3, 12, 9) // Visage

	// Cheveux blonds Ben
	ctx.fillStyle = '#FFD700'
	ctx.fillRect(benX + 7, benY + 1, 14, 4) // Cheveux du haut
	ctx.fillRect(benX + 5, benY + 4, 3, 4) // Cheveux côté gauche
	ctx.fillRect(benX + 20, benY + 4, 3, 4) // Cheveux côté droit

	// Bras de Ben qui enlacent Julia
	ctx.fillStyle = '#FFDBAC'
	ctx.fillRect(benX + 20, benY + 18, 8, 3) // Bras droit qui va vers Julia
	ctx.fillRect(juliaX + 4, benY + 20, 4, 3) // Main de Ben sur le dos de Julia

	// Bras de Julia qui enlacent Ben
	ctx.fillStyle = '#FFDBAC'
	ctx.fillRect(juliaX + 3, juliaY + 18, 8, 3) // Bras gauche qui va vers Ben
	ctx.fillRect(benX + 18, juliaY + 20, 4, 3) // Main de Julia sur le dos de Ben

	// Yeux fermés avec sourires (expression de bonheur)
	// Ben
	ctx.fillStyle = '#000000'
	ctx.fillRect(benX + 10, benY + 7, 2, 1) // Yeux fermés (ligne)
	ctx.fillRect(benX + 16, benY + 7, 2, 1)
	ctx.fillStyle = '#8B4513'
	ctx.fillRect(benX + 12, benY + 9, 4, 1) // Grand sourire

	// Julia
	ctx.fillStyle = '#000000'
	ctx.fillRect(juliaX + 10, juliaY + 7, 2, 1) // Yeux fermés (ligne)
	ctx.fillRect(juliaX + 16, juliaY + 7, 2, 1)
	ctx.fillStyle = '#FF1493'
	ctx.fillRect(juliaX + 12, juliaY + 9, 4, 1) // Grand sourire

	// Jambes
	ctx.fillStyle = '#FFDBAC'
	ctx.fillRect(benX + 10, benY + 39, 3, 6) // Jambe gauche Ben
	ctx.fillRect(benX + 15, benY + 39, 3, 6) // Jambe droite Ben
	ctx.fillRect(juliaX + 10, juliaY + 39, 3, 6) // Jambe gauche Julia
	ctx.fillRect(juliaX + 15, juliaY + 39, 3, 6) // Jambe droite Julia

	// Chaussures
	ctx.fillStyle = '#FFFFFF'
	ctx.fillRect(benX + 8, benY + 42, 5, 3) // Basket gauche Ben
	ctx.fillRect(benX + 15, benY + 42, 5, 3) // Basket droite Ben
	ctx.fillStyle = '#FF1493'
	ctx.fillRect(juliaX + 9, juliaY + 42, 4, 3) // Chaussure gauche Julia
	ctx.fillRect(juliaX + 15, juliaY + 42, 4, 3) // Chaussure droite Julia

	ctx.restore()
}
}

// Fonction pour dessiner l'effet visuel lors de la collecte
export const drawCollectEffect = (ctx: CanvasRenderingContext2D, x: number, y: number, opacity: number, scale: number, isHugEffect: boolean = false): void => {
ctx.save()

// Appliquer l'opacité
ctx.globalAlpha = opacity

if (isHugEffect) {
	// Dessiner des cœurs roses pour l'animation de câlin
	ctx.fillStyle = '#FF69B4'
	ctx.font = `${20 * scale}px Arial`
	ctx.textAlign = 'center'
	ctx.fillText('💕', x, y)

	// Ajouter un effet de scintillement
	if (Math.random() > 0.7) {
	ctx.fillStyle = '#FFD700'
	ctx.font = `${8 * scale}px Arial`
	ctx.fillText('✨', x + (Math.random() - 0.5) * 30, y + (Math.random() - 0.5) * 30)
	}
} else {
	// Dessiner des étoiles dorées qui tournent et grandissent (effet normal)
	const particles = [
	{ offsetX: 0, offsetY: -10, angle: 0 },
	{ offsetX: 8, offsetY: -5, angle: 45 },
	{ offsetX: 10, offsetY: 5, angle: 90 },
	{ offsetX: 0, offsetY: 12, angle: 135 },
	{ offsetX: -8, offsetY: 8, angle: 180 },
	{ offsetX: -12, offsetY: -2, angle: 225 }
	]

	particles.forEach((particle, i) => {
	const particleX = x + particle.offsetX * scale
	const particleY = y + particle.offsetY * scale - (1 - opacity) * 20 // Les particules montent en disparaissant

	// Étoile dorée
	ctx.fillStyle = '#FFD700'
	ctx.beginPath()
	for (let j = 0; j < 5; j++) {
		const angle = (j * Math.PI * 2 / 5) + (particle.angle * Math.PI / 180)
		const radius = 3 * scale
		const starX = particleX + Math.cos(angle) * radius
		const starY = particleY + Math.sin(angle) * radius
		if (j === 0) ctx.moveTo(starX, starY)
		else ctx.lineTo(starX, starY)
	}
	ctx.closePath()
	ctx.fill()
	})

	// Texte "+10" qui apparaît
	if (opacity > 0.7) {
	ctx.fillStyle = '#00FF00'
	ctx.font = 'bold 16px Arial'
	ctx.textAlign = 'center'
	ctx.fillText('+10', x, y - 15 * scale)
	}
}

ctx.restore()
}

// Classe de base pour le rendu des UI de jeu
export class GameUIRenderer {

static drawStartScreen(ctx: CanvasRenderingContext2D, canvasWidth: number, canvasHeight: number,
						title: string, subtitle: string, instructions: string[]): void {
	ctx.fillStyle = 'rgba(0,0,0,0.7)'
	ctx.fillRect(0, 0, canvasWidth, canvasHeight)

	ctx.fillStyle = '#FFD700'
	ctx.font = 'bold 32px Arial'
	ctx.textAlign = 'center'
	ctx.fillText(title, canvasWidth/2, 150)

	ctx.fillStyle = '#FFF'
	ctx.font = '20px Arial'
	ctx.fillText(subtitle, canvasWidth/2, 200)

	instructions.forEach((instruction, index) => {
	ctx.fillText(instruction, canvasWidth/2, 240 + (index * 30))
	})

	ctx.fillText('Cliquez pour commencer', canvasWidth/2, 240 + (instructions.length * 30) + 50)
}

static drawVictoryScreen(ctx: CanvasRenderingContext2D, cameraX: number, shouldFollowCamera: boolean,
						canvasWidth: number, canvasHeight: number, score: number,
						victoryTitle: string, victoryMessage: string, loveMessage: string): void {
	if (shouldFollowCamera) {
	ctx.fillStyle = 'rgba(255,215,0,0.9)'
	ctx.fillRect(cameraX, 0, canvasWidth, canvasHeight)

	ctx.fillStyle = '#8B0000'
	ctx.font = 'bold 32px Arial'
	ctx.textAlign = 'center'
	ctx.fillText(victoryTitle, cameraX + canvasWidth/2, 130)

	ctx.fillStyle = '#000'
	ctx.font = 'bold 24px Arial'
	ctx.fillText(victoryMessage, cameraX + canvasWidth/2, 170)

	ctx.fillStyle = '#8B0000'
	ctx.font = '20px Arial'
	ctx.fillText(`Score final: ${score}`, cameraX + canvasWidth/2, 210)
	ctx.fillText(loveMessage, cameraX + canvasWidth/2, 250)
	ctx.fillText('Cliquez pour continuer', cameraX + canvasWidth/2, 290)
	} else {
	ctx.fillStyle = 'rgba(255,215,0,0.9)'
	ctx.fillRect(0, 0, canvasWidth, canvasHeight)

	ctx.fillStyle = '#8B0000'
	ctx.font = 'bold 32px Arial'
	ctx.textAlign = 'center'
	ctx.fillText(victoryTitle, canvasWidth/2, 130)

	ctx.fillStyle = '#000'
	ctx.font = 'bold 24px Arial'
	ctx.fillText(victoryMessage, canvasWidth/2, 170)

	ctx.fillStyle = '#8B0000'
	ctx.font = '20px Arial'
	ctx.fillText(`Score final: ${score}`, canvasWidth/2, 210)
	ctx.fillText(loveMessage, canvasWidth/2, 250)
	ctx.fillText('Cliquez pour continuer', canvasWidth/2, 290)
	}
}

static drawGameOverScreen(ctx: CanvasRenderingContext2D, cameraX: number, shouldFollowCamera: boolean,
						canvasWidth: number, canvasHeight: number, score: number): void {
	if (shouldFollowCamera) {
	ctx.fillStyle = 'rgba(0,0,0,0.8)'
	ctx.fillRect(cameraX, 0, canvasWidth, canvasHeight)

	ctx.fillStyle = '#FF6B6B'
	ctx.font = 'bold 32px Arial'
	ctx.textAlign = 'center'
	ctx.fillText('Game Over!', cameraX + canvasWidth/2, 150)

	ctx.fillStyle = '#FFF'
	ctx.font = '20px Arial'
	ctx.fillText(`Score final: ${score}`, cameraX + canvasWidth/2, 200)
	ctx.fillText('Cliquez pour rejouer', cameraX + canvasWidth/2, 250)
	} else {
	ctx.fillStyle = 'rgba(0,0,0,0.8)'
	ctx.fillRect(0, 0, canvasWidth, canvasHeight)

	ctx.fillStyle = '#FF6B6B'
	ctx.font = 'bold 32px Arial'
	ctx.textAlign = 'center'
	ctx.fillText('Game Over!', canvasWidth/2, 150)

	ctx.fillStyle = '#FFF'
	ctx.font = '20px Arial'
	ctx.fillText(`Score final: ${score}`, canvasWidth/2, 200)
	ctx.fillText('Cliquez pour rejouer', canvasWidth/2, 250)
	}
}

static drawGameUI(ctx: CanvasRenderingContext2D, score: number, distance: number, canvasWidth: number): void {
	ctx.fillStyle = '#000'
	ctx.font = 'bold 20px Arial'
	ctx.textAlign = 'left'
	ctx.fillText(`Score: ${score}`, 10, 30)
	ctx.fillText(`Distance: ${Math.round(distance)}m`, 10, 60)

	// Instructions en jeu
	ctx.fillStyle = '#FFF'
	ctx.font = '14px Arial'
	ctx.textAlign = 'right'
	ctx.fillText('➡️ Accélérer | ESPACE Sauter', canvasWidth - 10, 30)
}

// ========== FONCTIONS SPÉCIALISÉES PAR NIVEAU ==========

// NIVEAU PARIS : Ben (player) court après Julia (target) et tend les bras
static drawBenParisLevel(ctx: CanvasRenderingContext2D, x: number, y: number, isRunning: boolean = false, runningTime: number = 0): void {
	ctx.save()

	// T-shirt bleu
	ctx.fillStyle = '#4169E1'
	ctx.fillRect(x + 5, y + 12, 18, 15)

	// Corps (peau)
	ctx.fillStyle = '#FFDBAC'
	ctx.fillRect(x + 8, y + 3, 12, 9) // Visage
	ctx.fillRect(x + 11, y + 9, 6, 6) // Cou

	// Cheveux blonds
	ctx.fillStyle = '#FFD700'
	ctx.fillRect(x + 7, y + 1, 14, 4)

	// Yeux
	ctx.fillStyle = '#000000'
	ctx.fillRect(x + 10, y + 6, 2, 2)
	ctx.fillRect(x + 16, y + 6, 2, 2)

	// Bouche (sourire déterminé quand il court)
	ctx.fillStyle = '#8B4513'
	if (isRunning) {
	ctx.fillRect(x + 12, y + 9, 4, 1) // Sourire déterminé plus large
	} else {
	ctx.fillRect(x + 13, y + 9, 2, 1) // Bouche normale
	}

	// Bras - PARIS : Ben tend les bras vers Julia (à droite)
	ctx.fillStyle = '#4169E1'
	if (isRunning) {
	const armWave = Math.sin(runningTime * 0.3) * 2

	// Bras gauche - mouvement de balancier
	ctx.fillRect(x + 5, y + 18 + armWave, 3, 9)

	// Bras droit - tendu vers Julia avec extension
	ctx.fillRect(x + 20, y + 18 - armWave, 6, 3)
	ctx.fillRect(x + 26, y + 19 - armWave, 4, 2) // Extension vers Julia

	// Mains expressives
	ctx.fillStyle = '#FFDBAC'
	ctx.fillRect(x + 5, y + 27 + armWave, 3, 3)
	ctx.fillRect(x + 29, y + 20 - armWave, 3, 3) // Main tendue vers Julia

	// Effet de mouvement
	ctx.fillStyle = 'rgba(255, 255, 255, 0.7)'
	ctx.fillRect(x + 32, y + 21 - armWave, 2, 1)
	ctx.fillRect(x + 31, y + 23 - armWave, 3, 1)
	} else {
	// Bras normaux
	ctx.fillRect(x + 5, y + 18, 3, 9)
	ctx.fillRect(x + 20, y + 18, 3, 9)

	ctx.fillStyle = '#FFDBAC'
	ctx.fillRect(x + 5, y + 27, 3, 3)
	ctx.fillRect(x + 20, y + 27, 3, 3)
	}

	// Jambes avec animation
	ctx.fillStyle = '#FFDBAC'
	if (isRunning) {
	const legOffset = Math.sin(runningTime * 0.4) * 2
	ctx.fillRect(x + 9 + legOffset, y + 39, 3, 12)
	ctx.fillRect(x + 16 - legOffset, y + 39, 3, 12)

	// Chaussures
	ctx.fillStyle = '#8B4513'
	ctx.fillRect(x + 8 + legOffset, y + 48, 5, 3)
	ctx.fillRect(x + 15 - legOffset, y + 48, 5, 3)
	} else {
	ctx.fillRect(x + 9, y + 39, 3, 12)
	ctx.fillRect(x + 16, y + 39, 3, 12)

	ctx.fillStyle = '#8B4513'
	ctx.fillRect(x + 8, y + 48, 5, 3)
	ctx.fillRect(x + 15, y + 48, 5, 3)
	}

	ctx.restore()
}

// NIVEAU PARIS : Julia (target) statique, ne tend pas les bras
static drawJuliaParisLevel(ctx: CanvasRenderingContext2D, x: number, y: number): void {
	ctx.save()

	// Robe rose
	ctx.fillStyle = '#FF69B4'
	ctx.fillRect(x + 8, y + 18, 12, 18)
	ctx.fillRect(x + 5, y + 30, 18, 9)

	// Corps (peau)
	ctx.fillStyle = '#FFDBAC'
	ctx.fillRect(x + 11, y + 12, 6, 9)
	ctx.fillRect(x + 10, y + 9, 8, 6)

	// Tête
	ctx.fillStyle = '#FFDBAC'
	ctx.fillRect(x + 8, y + 3, 12, 9)

	// Cheveux blonds
	ctx.fillStyle = '#FFD700'
	ctx.fillRect(x + 7, y + 1, 14, 4)
	ctx.fillRect(x + 5, y + 4, 3, 7)
	ctx.fillRect(x + 20, y + 4, 3, 7)

	// Yeux
	ctx.fillStyle = '#000000'
	ctx.fillRect(x + 10, y + 6, 2, 2)
	ctx.fillRect(x + 16, y + 6, 2, 2)

	// Bouche
	ctx.fillStyle = '#FF1493'
	ctx.fillRect(x + 13, y + 9, 2, 1)

	// Bras normaux (ne tend pas les bras)
	ctx.fillStyle = '#FFDBAC'
	ctx.fillRect(x + 6, y + 15, 3, 6)
	ctx.fillRect(x + 19, y + 15, 3, 6)

	// Jambes
	ctx.fillStyle = '#FFDBAC'
	ctx.fillRect(x + 10, y + 39, 3, 6)
	ctx.fillRect(x + 15, y + 39, 3, 6)

	// Chaussures roses
	ctx.fillStyle = '#FF1493'
	ctx.fillRect(x + 9, y + 42, 4, 3)
	ctx.fillRect(x + 15, y + 42, 4, 3)

	ctx.restore()
}

// NIVEAU VENISE : Julia (player) court après Ben et tend les bras
static drawJuliaVeniceLevel(ctx: CanvasRenderingContext2D, x: number, y: number, isRunning: boolean = false, runningTime: number = 0): void {
	ctx.save()

	// Robe rose avec détails vénitiens
	ctx.fillStyle = '#FF69B4'
	ctx.fillRect(x + 8, y + 18, 12, 18)
	ctx.fillRect(x + 5, y + 30, 18, 9)

	// Corps (peau)
	ctx.fillStyle = '#FFDBAC'
	ctx.fillRect(x + 11, y + 12, 6, 9)
	ctx.fillRect(x + 10, y + 9, 8, 6)

	// Tête
	ctx.fillStyle = '#FFDBAC'
	ctx.fillRect(x + 8, y + 3, 12, 9)

	// Cheveux blonds avec mouvement
	const swayOffset = isRunning ? Math.sin(runningTime * 0.3) * 2 : 0
	ctx.fillStyle = '#FFD700'
	ctx.fillRect(x + 7 + swayOffset * 0.5, y + 1, 14, 4)
	ctx.fillRect(x + 5 + swayOffset, y + 4, 3, 7)
	ctx.fillRect(x + 20 + swayOffset, y + 4, 3, 7)

	// Yeux
	ctx.fillStyle = '#000000'
	ctx.fillRect(x + 10, y + 6, 2, 2)
	ctx.fillRect(x + 16, y + 6, 2, 2)

	// Bouche
	ctx.fillStyle = '#FF1493'
	ctx.fillRect(x + 13, y + 9, 2, 1)

	// Bras - VENISE : Julia tend les bras vers Ben (à droite)
	ctx.fillStyle = '#FFDBAC'
	if (isRunning) {
	const armWave = Math.sin(runningTime * 0.3) * 2

	// Bras gauche - normal
	ctx.fillRect(x + 6, y + 15 + armWave, 3, 6)

	// Bras droit - tendu vers Ben avec extension
	ctx.fillRect(x + 19, y + 15 - armWave, 6, 3)
	ctx.fillRect(x + 25, y + 16 - armWave, 4, 2) // Extension vers Ben

	// Mains
	ctx.fillRect(x + 6, y + 21 + armWave, 3, 3)
	ctx.fillRect(x + 28, y + 17 - armWave, 3, 3) // Main tendue vers Ben

	// Effet de mouvement
	ctx.fillStyle = 'rgba(255, 182, 193, 0.7)'
	ctx.fillRect(x + 31, y + 18 - armWave, 2, 1)
	ctx.fillRect(x + 30, y + 20 - armWave, 3, 1)

	ctx.fillStyle = '#FFDBAC' // Restaurer la couleur
	} else {
	// Bras normaux
	ctx.fillRect(x + 6, y + 15, 3, 6)
	ctx.fillRect(x + 19, y + 15, 3, 6)
	}

	// Jambes avec animation
	ctx.fillStyle = '#FFDBAC'
	const legSwayOffset = isRunning ? Math.sin(runningTime * 0.3 + Math.PI) * 1 : 0
	ctx.fillRect(x + 10 + legSwayOffset, y + 39, 3, 6)
	ctx.fillRect(x + 15 - legSwayOffset, y + 39, 3, 6)

	// Chaussures roses
	ctx.fillStyle = '#FF1493'
	ctx.fillRect(x + 9 + legSwayOffset, y + 42, 4, 3)
	ctx.fillRect(x + 15 - legSwayOffset, y + 42, 4, 3)

	ctx.restore()
}

// NIVEAU VENISE : Ben (target) fuit, ne tend pas les bras
static drawBenVeniceLevel(ctx: CanvasRenderingContext2D, x: number, y: number, isRunning: boolean = false, runningTime: number = 0): void {
	ctx.save()

	// T-shirt bleu
	ctx.fillStyle = '#4169E1'
	ctx.fillRect(x + 5, y + 12, 18, 15)

	// Corps (peau)
	ctx.fillStyle = '#FFDBAC'
	ctx.fillRect(x + 8, y + 3, 12, 9)
	ctx.fillRect(x + 11, y + 9, 6, 6)

	// Cheveux blonds
	ctx.fillStyle = '#FFD700'
	ctx.fillRect(x + 7, y + 1, 14, 4)

	// Yeux (inquiets quand il fuit)
	ctx.fillStyle = '#000000'
	ctx.fillRect(x + 10, y + 6, 2, 2)
	ctx.fillRect(x + 16, y + 6, 2, 2)

	// Bouche (préoccupée)
	ctx.fillStyle = '#8B4513'
	ctx.fillRect(x + 13, y + 9, 2, 1)

	// Bras - VENISE : Ben fuit, bras en mouvement de course normale (ne tend pas)
	ctx.fillStyle = '#4169E1'
	if (isRunning) {
	const armWave = Math.sin(runningTime * 0.3) * 2

	// Bras en mouvement de course normale
	ctx.fillRect(x + 5, y + 18 + armWave, 3, 9)
	ctx.fillRect(x + 20, y + 18 - armWave, 3, 9)

	ctx.fillStyle = '#FFDBAC'
	ctx.fillRect(x + 5, y + 27 + armWave, 3, 3)
	ctx.fillRect(x + 20, y + 27 - armWave, 3, 3)
	} else {
	ctx.fillRect(x + 5, y + 18, 3, 9)
	ctx.fillRect(x + 20, y + 18, 3, 9)

	ctx.fillStyle = '#FFDBAC'
	ctx.fillRect(x + 5, y + 27, 3, 3)
	ctx.fillRect(x + 20, y + 27, 3, 3)
	}

	// Jambes avec animation
	ctx.fillStyle = '#FFDBAC'
	if (isRunning) {
	const legOffset = Math.sin(runningTime * 0.4) * 2
	ctx.fillRect(x + 9 + legOffset, y + 39, 3, 12)
	ctx.fillRect(x + 16 - legOffset, y + 39, 3, 12)

	ctx.fillStyle = '#8B4513'
	ctx.fillRect(x + 8 + legOffset, y + 48, 5, 3)
	ctx.fillRect(x + 15 - legOffset, y + 48, 5, 3)
	} else {
	ctx.fillRect(x + 9, y + 39, 3, 12)
	ctx.fillRect(x + 16, y + 39, 3, 12)

	ctx.fillStyle = '#8B4513'
	ctx.fillRect(x + 8, y + 48, 5, 3)
	ctx.fillRect(x + 15, y + 48, 5, 3)
	}

	ctx.restore()
}
}
